import { ArrowUpRight } from "lucide-react";
import { CONTACT } from "@/data/products";
import { MaskLines, FadeUp } from "./Reveal";

export const ContactBand = () => (
  <section data-testid="contact-band" className="grain relative overflow-hidden bg-[#FF5A00] text-[#0B0B0B]">
    <div className="mx-auto grid max-w-[1440px] gap-12 px-5 py-24 md:grid-cols-12 md:px-10 md:py-36">
      <div className="md:col-span-7">
        <p className="font-mono text-xs uppercase tracking-[0.25em]">Enquiries · MOQ 100 kg</p>
        <h2 className="font-wide mt-6 text-5xl font-black uppercase leading-[0.9] tracking-tight sm:text-6xl lg:text-8xl">
          <MaskLines onView lines={["Let's talk", "ink."]} />
        </h2>
      </div>
      <FadeUp className="flex flex-col justify-end gap-4 md:col-span-5">
        <a href={`tel:${CONTACT.tel}`} data-testid="band-phone-link" className="group flex items-center justify-between border-b-2 border-[#0B0B0B] py-5">
          <span>
            <span className="block font-mono text-xs uppercase tracking-[0.2em]">Phone</span>
            <span className="font-wide mt-1 block text-xl font-bold sm:text-3xl">{CONTACT.phone}</span>
          </span>
          <ArrowUpRight className="h-8 w-8 transition-transform duration-500 group-hover:rotate-45" />
        </a>
        <a href={`tel:${CONTACT.tel2}`} data-testid="band-phone2-link" className="group flex items-center justify-between border-b-2 border-[#0B0B0B] py-5">
          <span>
            <span className="block font-mono text-xs uppercase tracking-[0.2em]">Phone 2</span>
            <span className="font-wide mt-1 block text-xl font-bold sm:text-3xl">{CONTACT.phone2}</span>
          </span>
          <ArrowUpRight className="h-8 w-8 transition-transform duration-500 group-hover:rotate-45" />
        </a>
        <a href={`mailto:${CONTACT.email}`} data-testid="band-email-link" className="group flex items-center justify-between border-b-2 border-[#0B0B0B] py-5">
          <span>
            <span className="block font-mono text-xs uppercase tracking-[0.2em]">Email</span>
            <span className="font-wide mt-1 block text-xl font-bold sm:text-3xl">{CONTACT.email}</span>
          </span>
          <ArrowUpRight className="h-8 w-8 transition-transform duration-500 group-hover:rotate-45" />
        </a>
      </FadeUp>
    </div>
  </section>
);
